'use client';

import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { BlockedAlert } from '@/components/ui/blockedAlert';
import { setShowBlocked } from '@/lib/apiClient';

interface BlockedContextType {
  showBlocked: () => void;
  hideBlocked: () => void;
}

const BlockedContext = createContext<BlockedContextType | undefined>(undefined);

export function BlockedProvider({ children }: { children: ReactNode }) {
  const [isBlocked, setIsBlocked] = useState(false);
  const [mounted, setMounted] = useState(false);

  const showBlocked = () => setIsBlocked(true);
  const hideBlocked = () => setIsBlocked(false);

  useEffect(() => {
    setMounted(true);
    setShowBlocked(showBlocked);
  }, []);

  if (!mounted) {
    return <>{children}</>;
  }

  return (
    <BlockedContext.Provider value={{ showBlocked, hideBlocked }}>
      {children}
      <BlockedAlert show={isBlocked} onClose={hideBlocked} />
    </BlockedContext.Provider>
  );
}

export function useBlocked() {
  const context = useContext(BlockedContext);
  if (context === undefined) {
    throw new Error('useBlocked must be used within a BlockedProvider');
  }
  return context;
} 